import './App.css';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { getProfile } from './api/profileAPI';
import {
  getLoginAction,
  getSaveProfileAction,
  getSaveTokenAction
} from './redux/actions';

// Components
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import PreHeader from './components/preheader/PreHeader';
import SupportEngine from './components/ChatSupport/SupportEngine/index';
import ProtectedRoute from './components/routes/ProtectedRoutes';

// Pages (Unprotected)
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import FAQ from './pages/FAQ';
import Help from './pages/Help';
import ContactUs from './pages/ContactUs/ContactUs';

// Pages (Protected)

import AddProduct from './pages/addProduct/AddProduct';
import UpdateProfile from './pages/updateProfile/index';
import BookingHistory from './pages/bookingHistory';
import Chat from './pages/chat/Chat';
import BookingRequest from './pages/bookingRequest/BookingRequest';
import PartnerDispute from './pages/PartnerDispute';
import Feedback from './pages/feedback/Feedback';
import RentalEquipment from './pages/rentalEquipment/RentalEquipment';
import LandLeasing from './pages/LandLeasing/LandLeasing';
import EquipmentReport from './pages/EquipmentReport';
import CancellationPolicy from './pages/cancellationPage/CancellationPolicy';
import Dashboard from './pages/dashboard/Dashboard';
import LandLeasingDetails from './components/homeComponent/landLeasing/LandLeasingDetails';
import RentalEquipmentDetails from './pages/rentalEquipment/RentalEquimentDetials';
import CropRecommendationPage from './pages/cropPrediction/cropPrediciton';
import { CropProvider } from './context/CropContext';
import ActivationPage from './pages/activation/ActivationPage';
import { AuthProvider } from './context/AuthContext';

function App() {
  const dispatch = useDispatch();
  const tokenState = useSelector(state => state.tokenReducer);

  useEffect(
    () => {
      const access = Cookies.get('access-token');
      const refresh = Cookies.get('refresh-token');
      dispatch(
        getSaveTokenAction({
          accessToken: access,
          refreshToken: refresh
        })
      );
    },
    [tokenState.token.accessToken]
  );

  useEffect(() => {
    const access = Cookies.get('access-token');
    if (access) {
      const uuid = Cookies.get('uuid');
      dispatch(getLoginAction());
      getProfile({ uuid, accessToken: access }).then(data => {
        dispatch(getSaveProfileAction(data));
      });
    }
  }, []);

  return (
    <AuthProvider>
      <CropProvider>
        <PreHeader />
        <Header />
        <Routes>
          {/* Unprotected Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/help" element={<Help />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/policy" element={<CancellationPolicy />} />
          <Route path="*" element={<div>Not Found</div>} />
          <Route path="/crop" element={<CropRecommendationPage />} />
          <Route path="/land-leasing" element={<LandLeasing />} />
          <Route path="/land-leasing/:id" element={<LandLeasingDetails />} />
          <Route
            path="/activation/:activation_token"
            element={<ActivationPage />}
          />

          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="rental-equipment" element={<RentalEquipment />} />
          <Route
            path="/rental-equipment/:equipmentId"
            element={<RentalEquipmentDetails />}
          />
          <Route
            path="/addProduct"
            element={
              <ProtectedRoute>
                <AddProduct />
              </ProtectedRoute>
            }
          />
          <Route
            path="/update-profile"
            element={
              <ProtectedRoute>
                <UpdateProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/booking-history"
            element={
              <ProtectedRoute>
                <BookingHistory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/chat"
            element={
              <ProtectedRoute>
                <Chat />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bookingRequest/:id"
            element={
              <ProtectedRoute>
                <BookingRequest />
              </ProtectedRoute>
            }
          />
          {/* <Route
          path="/partner-dispute"
          element={
            <ProtectedRoute>
              <PartnerDispute />
            </ProtectedRoute>
          }
        /> */}
          <Route
            path="/feedback"
            element={
              <ProtectedRoute>
                <Feedback />
              </ProtectedRoute>
            }
          />
          <Route
            path="/rental-equipment"
            element={
              <ProtectedRoute>
                <RentalEquipment />
              </ProtectedRoute>
            }
          />
          <Route
            path="/land-leasing"
            element={
              <ProtectedRoute>
                <LandLeasing />
              </ProtectedRoute>
            }
          />
          {/* <Route
          path="/land-leasing/:id"
          element={
            <ProtectedRoute>
              <LandLeasingDetails />
            </ProtectedRoute>
          }
        /> */}
          <Route
            path="/equipment-report/:id"
            element={
              <ProtectedRoute>
                <EquipmentReport />
              </ProtectedRoute>
            }
          />
        </Routes>

        <Footer />
        <SupportEngine />
      </CropProvider>
    </AuthProvider>
  );
}

export default App;
